<template>
  <div class="w-full">
    <div class="flex items-center gap-4 p-4 bg-white rounded border border-gray-100">
      <div class="flex-1 flex items-center p-4 bg-gray-50 rounded cursor-pointer transition-all hover:bg-gray-100"
        @click="showFromPicker = true">
        <van-icon name="calendar-o" class="text-lg text-primary mr-4" />
        <div class="flex-col">
          <span class="text-sm text-gray mb-2">开始日期</span>
          <span class="text-base font-medium text-gray-800">{{ fromStr }}</span>
        </div>
      </div>

      <div class="flex items-center text-gray px-2">
        <van-icon name="arrow" />
      </div>

      <div class="flex-1 flex items-center p-4 bg-gray-50 rounded cursor-pointer transition-all hover:bg-gray-100"
        @click="showToPicker = true">
        <van-icon name="calendar-o" class="text-lg text-primary mr-4" />
        <div class="flex-col">
          <span class="text-sm text-gray mb-2">结束日期</span>
          <span class="text-base font-medium text-gray-800">{{ toStr }}</span>
        </div>
      </div>
    </div>

    <van-popup v-model:show="showFromPicker" position="bottom" round class="rounded-t-lg">
      <div class="text-center p-16 text-lg font-semibold text-gray-800 border-b border-gray-100">选择开始日期</div>
      <van-date-picker v-model="fromDate" type="date" @confirm="handleDateChange" @cancel="showFromPicker = false"
        :title="'选择开始日期'" show-toolbar />
    </van-popup>

    <van-popup v-model:show="showToPicker" position="bottom" round class="rounded-t-lg">
      <div class="text-center p-16 text-lg font-semibold text-gray-800 border-b border-gray-100">选择结束日期</div>
      <van-date-picker v-model="toDate" type="date" @confirm="handleDateChange" @cancel="showToPicker = false"
        :title="'选择结束日期'" show-toolbar />
    </van-popup>
  </div>
</template>

<script setup>
import { ref, computed, onMounted } from 'vue';
import apiUtil from "@/global/apiUtil";
import env from "@/global/env";
import util from "@/global/util";
import { defineProps, defineEmits } from 'vue';

const { DatePicker, Popup } = require('vant');

const props = defineProps({
  selectedFrom: String,
  selectedTo: String
});

const emit = defineEmits(['date-range-changed']);

const fromDate = ref([]);
const toDate = ref([]);
const fromStr = computed(() => util.formatDate(fromDate.value));
const toStr = computed(() => util.formatDate(toDate.value));
const showFromPicker = ref(false);
const showToPicker = ref(false);

const handleDateChange = () => {
  showFromPicker.value = false;
  showToPicker.value = false;
  emit('date-range-changed', fromStr, toStr);
};

const open = (picker) => {
  const pickerRef = picker === 'pickerFrom' ? fromDate : toDate;
  pickerRef.value = util.formatDate(new Date()); // Assuming you want to set the date to today when opening the picker
};

onMounted(() => {
  fromDate.value = util.formatDateArray(props.selectedFrom);
  toDate.value = util.formatDateArray(props.selectedTo);
});
</script>

<style>
/* 仅保留 Vant 组件的深度选择器样式 */
:deep(.van-picker) {
  background-color: white;
}

:deep(.van-picker__toolbar) {
  border-bottom: 1px solid #ebedf0;
}

:deep(.van-picker__title) {
  font-weight: 600;
  color: #2c3e50;
}

:deep(.van-picker__confirm) {
  color: #3498db;
}

:deep(.van-picker__cancel) {
  color: #7f8c8d;
}
</style>